import {
  colors,
  FAVOURITE_LARGE_SIZE,
  MODAL_CONTENT_CLASS_NAMES,
  PRODUCT_CAROUSEL_HEADING_CLASSNAME,
} from '@noths/polaris-client-ribbons-design-system';
import {
  maxBreakpoints,
  mediaQuery,
  minBreakpoints,
  pxToRem,
  responsiveFontSize,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { STAR_RATING_CONTAINER_CLASS } from 'src/components/molecules/StarRating';
import { STICKY_SECTION_CLASS } from 'src/components/molecules/StickySection';
import { BASKET_MODAL_CONTENT_LABEL } from '../constants/copy';

const { spacing, fonts, text } = theme;

export const AddToBasketModalGlobalStyles = createGlobalStyle`
  .${MODAL_CONTENT_CLASS_NAMES.base} {
    ${mediaQuery(
      { min: minBreakpoints.LARGE },
      css`
        &[aria-label='${BASKET_MODAL_CONTENT_LABEL}'] {
          grid-column: 3 / -3;
        }
      `,
    )}
  }
`;

export const bodyWrapper = css``;

export const addToBasketSection = css`
  display: flex;
  align-items: center;
  margin: ${pxToRem(spacing.xl)};
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};

  p,
  a,
  span {
    font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
    line-height: 1.67;
  }
`;

export const footerItems = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const productInfoWrapper = css`
  display: grid;
  flex-direction: column;

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      background-color: ${colors.neutralWhite};
      margin: 0 ${pxToRem(-16)};
      padding: ${pxToRem(spacing.xxl)} ${pxToRem(spacing.md)} 0;
    `,
  )}
`;

export const addToBasketProductSection = css`
  border-radius: ${pxToRem(20)};
  border: solid ${pxToRem(1)} ${colors.neutralLight};
  padding: ${pxToRem(spacing.xl)};
  gap: ${pxToRem(80)};
  flex-wrap: wrap;
`;

export const addToBasketCarouselSection = css`
  border-top: ${pxToRem(1)} solid ${colors.neutralLight};
  margin-bottom: ${pxToRem(spacing.xl)};

  ${mediaQuery(
    { max: maxBreakpoints.MEDIUM },
    css`
      margin-right: 0;
      .${PRODUCT_CAROUSEL_HEADING_CLASSNAME} {
        padding-right: ${pxToRem(spacing.xl)};
      }
    `,
  )}
`;

export const productDescription = css`
  margin: 0;
`;

export const productQuantity = css`
  margin: ${pxToRem(spacing.base)} 0;
`;

export const addToBasketButtonSection = css`
  flex-wrap: wrap;
`;

export const buttonContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      flex-basis: ${pxToRem(500)};
      flex-direction: row;
    `,
  )}
`;

export const basketInfo = css`
  flex-grow: 1;
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
  display: flex;

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      justify-content: center;
    `,
  )}
`;

export const basketInfoTotal = css`
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  margin-right: ${pxToRem(spacing.sm)};

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      margin-top: 0;
    `,
  )}
`;

export const basketInfoItems = css`
  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      margin-top: 0;
    `,
  )}
`;

export const addToBasketHeaderSection = css`
  margin: 0;
`;

export const addToBasketHeader = css`
  margin: 0 ${pxToRem(spacing.xs)};
  font-size: ${pxToRem(text.sm.SMALL.fontSize)};
`;

export const partnerInfo = css`
  display: flex;
  flex: 1;
  flex-basis: 50%;
  align-self: flex-start;
`;

export const partnerImage = css`
  margin-right: ${pxToRem(spacing.md)};
  border-radius: ${pxToRem(10)};
`;

export const basketBreakdownWrapper = css`
  flex: 1;
  align-self: flex-start;
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
  flex-basis: ${pxToRem(200)};
`;

export const goToBasketButton = css`
  margin-left: ${pxToRem(spacing.xxl)};

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      margin-top: ${pxToRem(spacing.sm)};
      margin-left: 0;
    `,
  )}
`;

export const calculationsSection = css`
  width: 100%;
`;

export const favouriteButton = css`
  position: absolute;
  margin-right: ${pxToRem(spacing.md)};
`;

export const ctaSectionWrapper = css`
  display: flex;
  align-items: center;
  margin: ${stack(spacing.xxl)};

  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      .${STICKY_SECTION_CLASS} & {
        margin: ${stack(spacing.lg)};
      }
    `,
  )}
`;

export const favouriteButtonWrapper = css`
  height: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  width: ${pxToRem(FAVOURITE_LARGE_SIZE)};
  position: relative;
  margin-right: ${pxToRem(spacing.xl)};
`;

export const ctaSectionWrapperWithoutDeliveryBlock = css`
  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      margin-bottom: 0;
    `,
  )}
`;

export const ctaButton = css`
  cursor: pointer;
`;

export const productInfoContainer = css`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      grid-column: 7 / span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 9 / span 3;
    `,
  )}
`;

export const divider = css`
  margin: ${pxToRem(spacing.lg - 2)} 0;
  border: 0;
  border-bottom: ${pxToRem(1)} solid ${colors.neutralLight};
`;

export const copy = css`
  margin: ${stack(36 - spacing.sm)};
`;

export const link = css`
  order: -1;
  margin: ${stack(spacing.sm)};
`;

export const inventoryLabel = css`
  color: ${colors.functionalRedPrimary};
  font-size: ${text.xxs.SMALL.fontSize}px;
`;

export const madeToOrder = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  ${responsiveFontSize(text.xxs)}
  margin: ${stack(spacing.sm)};

  [data-testid='tooltip-container'] {
    position: static;
  }

  [data-testid='content-wrapper'] {
    max-width: 243px;
  }

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      [data-testid='content-wrapper'] {
        max-width: none;
      }
    `,
  )};
`;

export const madeToOrderLabel = css`
  ${responsiveFontSize(text.xxs)}
  margin: 0;
`;

export const unavailableLabel = css`
  ${responsiveFontSize(text.xs)}
  width: ${pxToRem(330)};
  height: ${pxToRem(48)};
  padding: ${pxToRem(12)};
  border-radius: ${pxToRem(10)};
  background-color: ${colors.neutralLight};
  display: flex;
  margin: ${stack(28)};
`;

export const unavailableLabelIcon = css`
  margin-right: ${pxToRem(spacing.xs)};
`;

export const heading = css`
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  font-size: ${text.xl.SMALL.fontSize}px;
  line-height: 1.33;
  margin: ${stack(spacing.sm)};

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      font-size: ${text.xxl.SMALL.fontSize}px;
      line-height: 1.29;
    `,
  )};
`;

const productInfoFontSize = css`
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-size: ${pxToRem(text.md.SMALL.fontSize)};
  margin: ${stack(spacing.xs)};
  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      font-size: ${pxToRem(text.lg.SMALL.fontSize)};
    `,
  )};
`;

export const styledPrice = css`
  display: inline-block;
  ${productInfoFontSize}
  margin: 0;
`;

export const previousPrice = css`
  display: inline-block;
  ${productInfoFontSize}
  margin: 0 0 ${pxToRem(spacing.xs)} ${pxToRem(spacing.sm)};
`;

export const prices = css`
  position: static;
  margin: ${stack(spacing.lg)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const productRating = css`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: baseline;

  .${STAR_RATING_CONTAINER_CLASS} {
    margin: 0;
  }
`;

export const tooltipInfo = css`
  cursor: help;
  display: grid;
  grid-template-columns: 1fr ${pxToRem(16)};
  place-items: center;
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
`;

export const tooltipInfoIcon = css`
  display: block;
  height: ${pxToRem(16)};
  width: ${pxToRem(16)};
  margin: 0 0 0 ${pxToRem(spacing.base)};
`;

export const deliveryBlock = css`
  ${mediaQuery(
    { max: maxBreakpoints.SMALL },
    css`
      margin-bottom: ${pxToRem(spacing.xxl)};
    `,
  )}
`;

export const klarnaContainer = css`
  height: 70px;
  position: relative;
`;

export const klarnaSkeletonLoader = css`
  position: absolute;
`;
